// import React, { Component } from "react";
// import withRouter from "../../components/withRouter";
// import { connect } from "react-redux";
// import PropTypes from "prop-types";
// import { changeLayoutMode } from "../../redux/actions";

// //Import Components
// import LeftSidebarMenu from "./LeftSidebarMenu";

// class Index extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {};
//     this.capitalizeFirstLetter.bind(this);
//   }

//   //function for capital first letter of current page pathname
//   capitalizeFirstLetter = (string) => {
//     return string.charAt(1).toUpperCase() + string.slice(2);
//   };

//   componentDidMount() {
//     var getLayoutMode = localStorage.getItem("layoutMode");
//     this.props.changeLayoutMode(getLayoutMode);
//     if (getLayoutMode) {
//       this.props.changeLayoutMode(getLayoutMode);
//     } else {
//       this.props.changeLayoutMode(this.props.layout.layoutMode);
//     }

//     // let currentage = this.capitalizeFirstLetter(this.props.router.location.pathname);

//     //set document title according to page path name
//     // document.title = currentage + " | WMConnect - Responsive Bootstrap 5 Admin Dashboard";
//   }

//   render() {
//     return (
//       <React.Fragment>
//         <div className="layout-wrapper d-lg-flex justify-content-between">
//           {/* left sidebar menu */}
       
//           {/* render page content */}
//           {this.props.children}
//              <LeftSidebarMenu />
//         </div>
//       </React.Fragment>
//     );
//   }
// }

// Index.propTypes = {
//   layoutMode: PropTypes.any,
// };

// const mapStateToProps = (state) => {
//   const { layoutMode } = state.Layout;
//   return { layoutMode };
// };

// export default withRouter(
//   connect(mapStateToProps, { changeLayoutMode })(Index)
// );





import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import withRouter from "../../components/withRouter";
import { changeLayoutMode } from "../../redux/actions";

// Import Components
import LeftSidebarMenu from "./LeftSidebarMenu";

const Index = (props) => {
  const dispatch = useDispatch();
  const layoutMode = useSelector((state) => state.Layout.layoutMode);

  // Function to capitalize first letter after "/"
  const capitalizeFirstLetter = (string) => {
    return string.charAt(1).toUpperCase() + string.slice(2);
  };

  useEffect(() => {
    const getLayoutMode = localStorage.getItem("layoutMode");
    if (getLayoutMode) {
      dispatch(changeLayoutMode(getLayoutMode));
    } else {
      dispatch(changeLayoutMode(layoutMode));
    }

    // Optional: Set page title dynamically based on pathname
    // const currentPage = capitalizeFirstLetter(props.router.location.pathname);
    // document.title = `${currentPage} | WMConnect - Responsive Bootstrap 5 Admin Dashboard`;
  }, [dispatch, layoutMode, props.router.location.pathname]);

  return (
    <div className="layout-wrapper d-lg-flex justify-content-between">
      {/* render page content */}
      {props.children}
      <LeftSidebarMenu />
    </div>
  );
};

export default withRouter(Index);
